module.exports = __webpack_public_path__ + "img/DBP.1fff5024.jpg";